<template>
  <main>
    <div>
      <b>Request Details</b>
      <p class="py-2">Shipping Reference: {{ shipping.shippingReference }}</p>
      <p>
        Package: {{ shipping.consigneelocation ? fullRecieverAddress : "N/A" }}
      </p>
    </div>

    <div class="flex py-12 bg-gray-400 flex-wrap mt-3" v-if="isLoading && canShowMap && checkIfBookinIsNow">
      <div class="w-full flex justify-center">
        <span class="loader">
          <img src="@/assets/images/ondemand/loader.svg" /></span>
      </div>
      <p class="w-full text-center pt-4 px-3">
        Searching for a dispatcher.<br />
        Please be patient.
      </p>
    </div>

    <div v-if="canShowMap && checkPaymentType && !isLoading && checkIfBookinIsNow" class="mt-4">
      <div class="flex items-center justify-between pb-3">
        <div>Local Shipment</div>
        <div class=" text-primary-yellow">
          {{ shipping.shippingReference ? shipping.shippingReference : "N/A" }}
        </div>
      </div>
      <div>
        <GmapMap :center="center" :zoom="14" style="width:100%; height:400px">
          <gmap-polyline :path="polyLines" :options="polyOptions" />
          <gmap-marker :position="origin" label="🚖" />
          <gmap-marker :position="destination" :label="distinationLabel" />
        </GmapMap>
      </div>

      <div v-if="!loading" class="shadow-md bg-gray-100 mt-4 rounded p-3">
        <div class="mt-2 border-b-2 pb-1 border-dashed border-gray-300">
          <div class="flex pb-2 items-center">
            <span class="block w-6/12 text-gray-500">Description</span>
            <span class="w-6/12 flex items-center justify-end">{{ totalpackageDiscription }}
              <button @click="isMinimize = !isMinimize" class="text-primary-yellow text-3xl ml-2">
                {{ isMinimize ? "&minus;" : "&plus;" }}
              </button>
            </span>
          </div>
          <div class="flex pb-2" v-if="isMinimize">
            <span class="block w-6/12 text-gray-500">Receiver</span>
            <span class="block w-6/12 text-right">{{
              shipping.consigneelocation
                ? shipping.consigneelocation.contactName ||
                shipping.consigneelocation.contactPerson
                : "N/A"
            }}
              ({{
                shipping.consigneelocation
                  ? shipping.consigneelocation.mobile
                  : "N/A"
              }})</span>
          </div>
          <div class="flex pb-2" v-if="isMinimize">
            <span class="block w-6/12 text-gray-500">Sender</span>
            <span class="block w-6/12 text-right">{{
              shipping.shipperlocation
                ? shipping.shipperlocation.contactName
                : "N/A"
            }}
              ({{
                shipping.shipperlocation
                  ? shipping.shipperlocation.mobile
                  : "N/A"
              }})</span>
          </div>
        </div>

        <div class="mt-2 border-b-2 pb-1 border-dashed border-gray-300">
          <div class="flex pb-2" v-if="liveTripData.status == 'accepted'">
            <span class="block w-6/12 text-gray-500">Pick-Up Time</span>
            <span class="block w-6/12 text-right">{{
              liveTripData.origin
                ? displayPickupTime()
                : "N/A"
            }}
            </span>
          </div>
          <div class="flex pb-2" v-if="liveTripData.status == 'in-transit'">
            <span class="block w-6/12 text-gray-500">Estimated Delivery time</span>
            <span class="block w-6/12 text-right">{{ liveTripData.info ? liveTripData.info.duration.text : "---" }}
            </span>
          </div>
          <div class="flex pb-2">
            <span class="block w-6/12 text-gray-500">Payment</span>
            <span class="block w-6/12 text-right">{{
              shipping.transaction ? shipping.transaction.paymentStatus : "N/A"
            }}</span>
          </div>
        </div>

        <div class="mt-2 border-b-2 pb-1 border-dashed border-gray-300">
          <div class="flex pb-2">
            <span class="block w-6/12 text-gray-500">{{ Dispatcher }}</span>
            <span class="block w-6/12 text-right">{{ liveTripData.driver ? liveTripData.driver.firstname : "" }}
              {{
                liveTripData.driver ? liveTripData.driver.lastname : ""
              }}</span>
          </div>
          <div class="flex pb-2">
            <span class="block w-6/12 text-gray-500">Mobile No.</span>
            <span class="block w-6/12 text-right">{{
              liveTripData.driver ? liveTripData.driver.mobile_no : ""
            }}</span>
          </div>
          <div class="flex pb-2">
            <span class="block w-6/12 text-gray-500">Fleet</span>
            <span class="block w-6/12 text-right">{{
              liveTripData.driver && liveTripData.driver.fleet
                ? liveTripData.driver.fleet.vehicleType
                : "N/A"
            }}
              |
              {{
                liveTripData.driver && liveTripData.driver.fleet
                  ? liveTripData.driver.fleet.vehicleNumber
                  : "N/A"
              }}
            </span>
          </div>
          <div class="flex pb-2">
            <span class="block w-6/12 text-gray-500">Status</span>
            <span class="block w-6/12 text-right text-primary-green capitalize">{{
              liveTripData.status || tripAccepted.status
                ? liveTripData.status || tripAccepted.status
                : "N/A"
            }}</span>
          </div>
        </div>

        <div class="mt-5 flex justify-between">
          <button @click="routeToActiveBooking">Close</button>
        </div>
      </div>
    </div>


    <div class="flex justify-center flex-wrap py-24 mt-4 bg-white"
      v-if="canShowMap && checkPaymentType && !isLoading && !checkIfBookinIsNow">
      <p class="text-base text-center w-10/12 opacity-75">
        You have scheduled this shipment to be booked on <b>{{ bookingDateInUtc }}</b>. A dispatcher will be made
        available to
        handle the delivery on the due date.
      </p>
      <p class="mt-8 flex justify-center w-full">
        <button class="py-2 px-12 bg-primary-yellow rounded cursor-pointer" @click="$router.push('/active-bookings')">Go
          to view bookings</button>
      </p>
    </div>

    <div class="flex justify-center mt-10">
      <button class="py-2 px-4 rounded" @click="$router.push('/dashboard')">Go to dashboard</button>
    </div>

    <SuccessShipping v-if="!canShowMap && checkPaymentType" :showModal="showCancleBookingModal"
      @close-modal="showCancleBookingModal = false" :endRoute="endRoute" />

    <FailedBooking v-if="!checkPaymentType && !shipmentLoading" :showModal="showCancleFailedbooking"
      @close-modal="showCancleFailedbooking = false" :endRoute="endRoute" />
  </main>
</template>

<script>
// import DirectionsRenderer from "./module/DirectionRender.js";
import SuccessShipping from "./modals/SuccessShippment.vue";
import FailedBooking from "./modals/FailedBooking.vue";
import moment from "moment";
import SocketioService from "../../../services/socketio.service";

export default {
  components: {
    // DirectionsRenderer,
    SuccessShipping,
    FailedBooking,
  },
  props: {
    aboutToExit: Boolean,
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  created() {
    SocketioService.setupSocketConnection();
  },
  data() {
    return {
      directions: [
        {
          origin: { lat: 37.7749, lng: -122.4194 },
          destination: { lat: 37.7749, lng: -122.5194 },
          zoomLevel: 15,
          polyline: {
            path: [],
            geodesic: true,
            strokeColor: "#FF0000",
            strokeOpacity: 1.0,
            strokeWeight: 2,
          },
        },
        // Add more direction objects if needed
      ],
      tripObj: {},
      loading: false,
      shipmentLoading: true,
      isMinimize: true,
      shipping: {},
      endRoute: "",
      origin: {},
      interval: null,
      showCancleBookingModal: true,
      shippingMethod: "",
      shippingStatus: undefined,
      showCancleFailedbooking: true,
      isLoading: false,
      tripId: "",
      center: {},
      path: [], // filled in mounted()
      polyOptions: {
        strokeColor: 'rgb(9,183,138)',
        strokeOpacity: 0.7,
        strokeWeight: 5
      },
      dispatcher: {},
      tripData: {},
      states: {},
      hasRequestOccured: false,
      destination: {},
      load: false,
      socketEventName: "",
      liveTripData: {},
      tripsDetails: {},
      tripLoaded: false,
    };
  },

  sockets: {
    connect: function () { },
  },
  watch: {
    center: {
      handler() {
        // Do not auto focus, manage map bounds manually
        this.updateMapBounds();
      },
      deep: true
    },
    aboutToExit() {
      this.sockets.unsubscribe(this.shipping.id);
      this.sockets.unsubscribe(this.tripId);
      this.sockets.unsubscribe("trip_driver");
    },
    tripId(val) {
      this.socketEventName = val;

      this.interval = setInterval(() => {
        SocketioService.tripInfo(val).then((data) => {
          this.liveTripData = data;
          const polyline = data.polyline || data?.info?.polyline || []
          this.path = polyline;
          this.center = { lat: polyline[0][0], lng: polyline[0][1] };
          this.origin = { lat: polyline[0][0], lng: polyline[0][1] };
          this.destination = { lat: polyline[polyline.length - 1][0], lng: polyline[polyline.length - 1][1] };
          this.isLoading = false;
        });
      }, 5000);
    },
    "shipping.id"(val) {
      localStorage.setItem("bookinDirectionShippingId", val);
      this.sockets.subscribe(val, (data) => {
        if (data.shippingId !== this.shipping.id) return;
        this.liveTripData = data;
        const polyline = data.polyline || data?.info?.polyline || []
        this.path = polyline;
        this.center = { lat: polyline[0][0], lng: polyline[0][1] };
        this.origin = { lat: polyline[0][0], lng: polyline[0][1] };
        this.destination = { lat: polyline[polyline.length - 1][0], lng: polyline[polyline.length - 1][1] };
        this.isLoading = false;
        this.tripAccepted(data);

        SocketioService.registerTripId(data.id);
      });
    },
  },
  mounted() {
    this.getShipping();
    this.geolocate();
  },
  activated() {
    this.getShipping();
    this.geolocate();
  },
  computed: {
    distinationLabel() {
      return this.liveTripData.status == "accepted" ? this.shipping?.shipperlocation?.contactName : this.shipping?.consigneelocation?.contactName;
    },
    polyLines() {
      return (this.path || []).map(([lat, lng]) => ({ lng, lat }));
    },
    destinationLabel() {
      switch (this.liveTripData.status) {
        case 'accepted':
          return this.shipping.shipperlocation.contactName
        case 'in-transit':
          return this.shipping.consigneelocation.contactPerson

        default:
          return ''
      }
    },
    originLabel() {
      return (this.liveTripData.status == "accepted" || this.liveTripData.status == "in-transit") ? "Driver" : ''
    },
    bookingDateInUtc() {
      return moment(this.tripObj.orderDate).format("dddd, MMMM D, YYYY")
    },
    checkIfBookinIsNow() {
      const givenDate = new Date(this.tripObj.orderDate);
      const currentDate = new Date();

      // Compare year, month, and day
      return givenDate.getUTCMonth() == currentDate.getUTCMonth() &&
        givenDate.getUTCDate() == currentDate.getUTCDate()
        && givenDate.getUTCFullYear() == currentDate.getUTCFullYear()
        ;
    },
    totalpackageDiscription() {
      if (this.shipping?.packagees?.length < 1) return "";
      return this.shipping?.packagees
        .map((item) => item?.description)
        .reduce((prev, next) => prev + ", " + next);
    },
    Dispatcher() {
      let handler = this.liveTripData?.driver?.fleet?.vehicleType?.toLowerCase();
      switch (handler) {
        case "bike":
          handler = "Rider of Bike";
          break;
        case "truck":
          handler = "Driver of Truck";
          break;
        case "car":
          handler = "Driver of Car";
          break;
        default:
          break;
      }
      return handler;
    },
    createTripPayload() {
      return {
        bookingChannel: "muleex",
        bookingDate: this.shipping?.createdAt,
        destination: {
          address: this.shipping.consigneelocation
            ? this.shipping.consigneelocation?.address?.name
            : "N/A",
          lat: this.shipping.consigneelocation
            ? this.shipping.consigneelocation?.address?.lat
            : "N/A",
          long: this.shipping.consigneelocation
            ? this.shipping.consigneelocation?.address?.lng
            : "N/A",
          user: {
            name: this.shipping.consigneelocation
              ? this.shipping.consigneelocation?.contactName ||
              this.shipping.consigneelocation?.consigneelocation?.contactPerson
              : "N/A",
            phoneNumber: this.shipping.consigneelocation
              ? this.shipping.consigneelocation?.mobile
              : "N/A",
            email: this.shipping.consigneelocation
              ? this.shipping.consigneelocation?.email
              : "N/A",
          },
        },
        loadWeight: this.getLoadWeight,
        orderDate: this.formatOrderDate(this.$store.getters?.getSenderDropDate),
        origin: {
          address: this.shipping.shipperlocation
            ? this.shipping.shipperlocation?.address?.name
            : "N/A",
          lat: this.shipping.shipperlocation
            ? this.shipping.shipperlocation?.address?.lat
            : "N/A",
          long: this.shipping.shipperlocation
            ? this.shipping.shipperlocation.address.lng
            : "N/A",
          user: {
            name: this.shipping.shipperlocation
              ? this.shipping.shipperlocation.contactName ||
              this.shipping.shipperlocation.contactPerson
              : "N/A",
            phoneNumber: this.shipping.shipperlocation
              ? this.shipping.shipperlocation.mobile
              : "N/A",
            email: this.shipping.shipperlocation
              ? this.shipping.shipperlocation.email
              : "N/A",
          },
        },
        tripCost: Number(this.shipping?.transaction?.totalValue) || 0,
        shippingId: this.shipping.id,
        status: "pending",
        vehicleType:
          this.$store.getters.latestNewCostEngine.vehicleType || "Truck",
        paymentType: this.$store.getters?.getBookingpaymenttype.toLowerCase()
      };
    },
    canShowMap() {
      return (
        this.shippingMethod == "door-to-door" ||
        (this.shippingMethod == "terminal-to-door" &&
          !this.shipping.shippingservice)
      );
    },
    fullRecieverAddress() {
      return this.extractAddress(this.shipping.consigneelocation.address);
    },
    getLoadWeight() {
      if (this.shipping?.packagees?.length < 1) return 0;
      const totalLoadWeight = (this.shipping?.packagees || [])
        .map((item) => item?.estimatedWeight)
        .reduce((prev, next) => prev + next);
      return totalLoadWeight || 0;
    },
    checkPaymentType() {
      if (this.shipping?.transaction?.payment_type == 'cash') return true
      return (
        (this.shipping?.transaction?.paymentStatus || "").toLowerCase() ===
        "paid"
      );
    },
    shippingId() {
      return this.$route.params.id;
    },
  },
  updated() {
    console.log(
      "center",
      this.center,
      "destination",
      this.destination,
      "origin",
      this.origin
    );
  },
  methods: {
    formatOrderDate(val) {
      // Create a moment object with the current date and time
      const currentMoment = moment();
      if (!val) return null
      val = val.split('-')

      // Get the year, month, and date for 2024-07-02
      const year = val[0];
      const month = val[1] - 1; // Month is 0-based, so 6 represents July
      const day = val[2];

      // Set the moment object to 2024-07-02 with the current time
      const customDate = currentMoment.set({
        year: year,
        month: month,
        date: day
      });

      // Format the date to ISO 8601 with milliseconds and UTC timezone
      const formattedDate = customDate.toISOString();
      return formattedDate;
    },
    updateMapBounds() {
      if (this.map && this.center[0] && this.center[1]) {
        const bounds = new window.google.maps.LatLngBounds();
        bounds.extend(new window.google.maps.LatLng(this.center[0].lat, this.center[0].lng));
        bounds.extend(new window.google.maps.LatLng(this.center[1].lat, this.center[1].lng));
        this.map.fitBounds(bounds);
      }
    },
    displayPickupTime() {
      // Input iOS date string            
      const iosDateString = this.liveTripData?.departure_time;

      // Parse the iOS date string using Moment.js
      const iosDate = moment(iosDateString);

      // Add 900 seconds
      const newIosDate = iosDate.add(this.liveTripData?.info?.duration?.value || 0, "seconds");

      // Format the new date as "YYYY-MM-DD, hh:mm"
      const formattedDate = newIosDate.format("YYYY-MM-DD, hh:mm");
      return formattedDate;
    },
    async getTripDetails(payload) {
      try {
        const response = await this.$_getEstimatedLocationTime(payload);
        this.tripsDetails = response.data.data;
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isLoading = false;
      }
    },
    changeTimeFormat(val) {
      return moment(val).format("DD-MM-YYYY, hh:mm") ?? "";
    },
    routeToActiveBooking() {
      this.$router.push("/active-bookings");
    },
    async tripAccepted(val) {
      this.tripData = val;
    },
    setPlace(val) {
      console.log(val);
    },
    GetCurrentZoom(val) {
      this.zoomLevel = val
    },
    geolocate: function () {
      this.origin = {
        lat: Number(this.shipping.shipperlocation?.address.lat ?? 0),
        lng: Number(this.shipping.shipperlocation?.address.lng ?? 0),
      };
    },
    async getAllLocation() {
      const payload = {
        arrivalLocation: {
          lat: this.activeShipping?.consignee?.address?.lat,
          lng: this.activeShipping?.consignee?.address?.lng,
        },
        takeOffLocation: {
          lat: this.activeShipping?.shipper?.address?.lat,
          lng: this.activeShipping?.shipper?.address?.lng,
        },
      };

      try {
        const response = await this.$_getTerminals(payload);
        this.locations = response.data.data;
      } catch (error) {
        this.handleError(error);
      }
    },
    async creatTripRequest() {
      // if (this.$store.getters.latestNewBooking.hasSentTrips) return;
      this.isLoading = true;
      await this.$apollo
        .mutate({
          mutation: this.$_GraphQL_Endpoint.getOldBookingDispatchDriver,
          variables: {
            newTripData: this.createTripPayload,
          },
        })
        .then((res) => {
          console.log("createTripRequest res", res);
          this.tripId = res?.data?.createTrip?.trip?.id;
          this.tripObj = res?.data?.createTrip?.trip
          if (
            res?.data?.createTrip?.trip?.status == "in-transit" ||
            res?.data?.createTrip?.trip?.status == "accepted" ||
            (res?.data?.createTrip?.trip?.status == "pending" && !this.checkIfBookinIsNow)
          ) {
            this.isLoading = false;
          }
          if (res.message == "No drivers available") {
            this.generateToast(res.message, "error");
          }
          this.$store.commit("SET_BOOKING_HAS_SET_TRIPS", true);
        });
    },
    async getShipping() {
      this.shipmentLoading = true;
      try {
        const response = await this.$_getShipmentById(this.shippingId);
        this.shipping = response.data.data.shipping;
        this.tripId = response.data.data.shipping.tripId;
        this.endRoute = `${this.shipping.shippingservice?.takeOff?.address}
        ${this.shipping.shippingservice?.takeOff?.city},
        ${this.shipping.shippingservice?.takeOff?.state}
        ${this.shipping.shippingservice?.takeOff?.country} (<em style='opacity: 0.5; font-weight:500'>${this.shipping.shippingservice?.orgName}</em>)
         `;

        this.shippingMethod = this.shipping?.shippingMethod;
        this.shippingStatus = this.shipping.paymentStatus;

        this.center = [
          {
            lat: this.shipping.shipperlocation?.address.lat || 0,
            lng: this.shipping.shipperlocation?.address.lng || 0,
          },
          {
            lat: this.shipping.consigneelocation?.address.lat || 0,
            lng: this.shipping.consigneelocation?.address.lng || 0,
          },
        ];
        this.load = true;
        this.states = this.$store.getters.getBookingStates;

        if (
          this.shippingMethod == "door-to-door"
        ) {
          !this.$store.getters.latestNewBooking.hasSentTrips && !this.shipping.tripId && (await this.creatTripRequest());
        }
        if (this.shipping.tripId) {
          this.load = true;
          this.isLoading = false;
          this.tripId = this.shipping.tripId
        }
      } catch (error) {
        //
      } finally {
        this.shipmentLoading = false;
      }
    },
  },
  beforeDestroy() {
    SocketioService.disconnect();
    clearInterval(this.interval);
  },
};
</script>

<style lang="scss" scoped>
.loader {
  display: inline-block;
  width: auto;
  height: auto;
  animation: 2s infinite linear rolls;
}

@keyframes rolls {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
